enum SidebarMenuItemType {
  Route = "route",
  Heading = "heading",
  Collapse = "collapse",
  Link = "link",
  DynamicLink = "dynamicLink"
};

export default SidebarMenuItemType;